import React, { useState, useEffect } from 'react';
import { 
    Save, X, DollarSign, Settings, AlertTriangle, Search, ChevronDown, ChevronRight, Layers
} from 'lucide-react';

import config from '../config';

const debugCompanySettings = (settings, companies, companyId, companyName) => {
    console.log(`=== تشخيص الشركة: ${companyName} (ID: ${companyId}) ===`);
    
    const currentSetting = settings.find(s => s.companyId.toString() === companyId.toString());
    console.log('الإعدادات الحالية في الحالة:', currentSetting);
    
    const localData = JSON.parse(localStorage.getItem('companySettings') || '[]');
    const localSetting = localData.find(s => s.companyId.toString() === companyId.toString());
    console.log('الإعدادات في localStorage:', localSetting);
    
    console.log('نوع معرف الشركة:', typeof companyId, companyId);
    console.log('نوع معرف الشركة في الإعدادات:', typeof currentSetting?.companyId, currentSetting?.companyId);
    
    return { currentSetting, localSetting };
};

const CommissionSettings = ({ isOpen, onClose }) => {
    const [companies, setCompanies] = useState([]);
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [search, setSearch] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [activeTab, setActiveTab] = useState('companies'); // 'companies' or 'global'
    
    // إعدادات عامة
    const [globalSettings, setGlobalSettings] = useState({
        contractCommission: 200,
        taqeebCommission: 150,
        useGlobalSettings: true
    });
    
// دالة اختبار الاتصال
const testConnection = async () => {
    try {
        console.log("بدء اختبار الاتصال...");
        const response = await fetch(`${config.DELEGATES_API_URL}/api/test`);
        const data = await response.json();
        console.log("نتيجة اختبار الاتصال:", data);
        alert("تم الاتصال بالخادم بنجاح: " + data.message);
    } catch (error) {
        console.error("خطأ في اختبار الاتصال:", error);
        alert("فشل الاتصال بالخادم: " + error.message);
    }
};

// دالة اختبار إرسال البيانات
const testSendData = async () => {
    try {
        console.log("بدء اختبار إرسال البيانات...");
        const response = await fetch(`${config.DELEGATES_API_URL}/api/test`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                contractCommission: 200,
                taqeebCommission: 150
            })
        });
        const data = await response.json();
        console.log("نتيجة اختبار إرسال البيانات:", data);
        alert("تم إرسال البيانات بنجاح: " + JSON.stringify(data.receivedData));
    } catch (error) {
        console.error("خطأ في اختبار إرسال البيانات:", error);
        alert("فشل إرسال البيانات: " + error.message);
    }
};



// دالة للتحقق من جدول قاعدة البيانات
const checkDatabaseTable = async () => {
    try {
        console.log("جاري التحقق من جدول قاعدة البيانات...");
        const response = await fetch(`${config.DELEGATES_API_URL}/api/check-table/GlobalCommissionSettings`);
        const data = await response.json();
        console.log("نتيجة فحص جدول قاعدة البيانات:", data);
        
        if (data.exists) {
            alert(`الجدول موجود في قاعدة البيانات. الأعمدة: ${data.columns.map(c => c.name).join(', ')}`);
        } else {
            // إذا لم يكن الجدول موجودًا، اعرض خيار إنشائه
            if (window.confirm('الجدول غير موجود في قاعدة البيانات. هل ترغب في إنشائه؟')) {
                createDatabaseTable();
            }
        }
    } catch (error) {
        console.error("خطأ في فحص جدول قاعدة البيانات:", error);
        alert("خطأ في فحص جدول قاعدة البيانات: " + error.message);
    }
};


const createDatabaseTable = async () => {
    try {
        console.log("جاري إنشاء جدول قاعدة البيانات...");
        const response = await fetch(`${config.DELEGATES_API_URL}/api/create-global-settings-table`);
        const data = await response.json();
        console.log("نتيجة إنشاء جدول قاعدة البيانات:", data);
        
        if (data.success) {
            alert("تم إنشاء الجدول بنجاح! يمكنك الآن حفظ الإعدادات العامة.");
        } else {
            alert("فشل في إنشاء الجدول: " + (data.error || 'خطأ غير معروف'));
        }
    } catch (error) {
        console.error("خطأ في إنشاء جدول قاعدة البيانات:", error);
        alert("خطأ في إنشاء جدول قاعدة البيانات: " + error.message);
    }
};



    // جلب قائمة الشركات عند فتح النافذة
    useEffect(() => {
        if (isOpen) {
            fetchCompanies();
            fetchGlobalSettings(); // تأكد من استدعاء هذه الدالة
        }
    }, [isOpen]);
    
    // دالة لجلب قائمة الشركات
    const fetchCompanies = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${config.DELEGATES_API_URL}/api/companies`);
            if (!response.ok) {
                throw new Error('فشل في جلب قائمة الشركات');
            }
            const data = await response.json();
            setCompanies(data);
            
            // جلب إعدادات العمولات لجميع الشركات
            fetchAllSettings(data);
        } catch (error) {
            console.error('خطأ في جلب قائمة الشركات:', error);
            setError('حدث خطأ في جلب قائمة الشركات');
        } finally {
            setLoading(false);
        }
    };
    
    // دالة لجلب الإعدادات العامة
    const fetchGlobalSettings = async () => {
        try {
            console.log("جلب الإعدادات العامة...");
            const response = await fetch(`${config.DELEGATES_API_URL}/api/simple-settings`);
            const data = await response.json();
            console.log("الإعدادات المسترجعة:", data);
            
            setGlobalSettings({
                contractCommission: data.contractCommission || 200,
                taqeebCommission: data.taqeebCommission || 150,
                useGlobalSettings: true
            });
        } catch (error) {
            console.error('خطأ في جلب الإعدادات العامة:', error);
            // استخدام القيم الافتراضية في حالة الخطأ
            setGlobalSettings({
                contractCommission: 200,
                taqeebCommission: 150,
                useGlobalSettings: true
            });
        }
    };
    
    
    const fetchAllSettings = async (companiesList) => {
        try {
            setLoading(true);
            
            let data = [];
            try {
                const response = await fetch(`${config.DELEGATES_API_URL}/api/commission-settings/all`);
                if (response.ok) {
                    data = await response.json();
                }
            } catch (serverError) {
                console.warn('خطأ في جلب البيانات من الخادم:', serverError);
            }
            
            if (data.length === 0) {
                data = JSON.parse(localStorage.getItem('companySettings') || '[]');
            }
            
            // إضافة اسم الشركة إلى إعدادات العمولة مع التأكد من نوع البيانات
            const enhancedSettings = data.map(setting => {
                const company = companiesList.find(c => 
                    c.CompanyID.toString() === setting.companyId.toString() // ← تصحيح المقارنة
                );
                return {
                    ...setting,
                    companyId: parseInt(setting.companyId), // ← توحيد نوع البيانات
                    companyName: company ? company.CompanyName : 'شركة غير معروفة'
                };
            });
            
            setSettings(enhancedSettings);
        } catch (error) {
            console.error('خطأ في جلب إعدادات العمولات:', error);
            setError('حدث خطأ في جلب إعدادات العمولات');
        } finally {
            setLoading(false);
        }
    };
    
    const saveCompanySettings = async (companyId, companySettings) => {
        try {
            setLoading(true);
            
            // حفظ في localStorage للاختبار المؤقت
            const existingSettings = JSON.parse(localStorage.getItem('companySettings') || '[]');
            const updatedSettings = existingSettings.filter(s => s.companyId !== companyId);
            updatedSettings.push({ companyId, ...companySettings });
            localStorage.setItem('companySettings', JSON.stringify(updatedSettings));
            
            // حاول الحفظ على الخادم
            const response = await fetch(`${config.DELEGATES_API_URL}/api/commission-settings/${companyId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(companySettings)
            });
            
            if (!response.ok) {
                console.warn('فشل في حفظ البيانات على الخادم، تم الحفظ محلياً فقط');
            }
            
            // تحديث الإعدادات في الحالة المحلية
            setSettings(prevSettings => 
                prevSettings.map(setting => 
                    setting.companyId === companyId ? { ...setting, ...companySettings } : setting
                )
            );
            
            return true;
        } catch (error) {
            console.error('خطأ في حفظ إعدادات العمولة:', error);
            setError(`خطأ في حفظ إعدادات العمولة: ${error.message}`);
            return false;
        } finally {
            setLoading(false);
        }
    };
    
// دالة لحفظ الإعدادات العامة - نسخة محسنة
const saveGlobalSettings = async () => {
    try {
        setLoading(true);
        setError('');
        
        console.log("حفظ الإعدادات:", globalSettings);
        
        // تحويل القيم للتأكد من أنها أرقام
        const contractValue = Number(globalSettings.contractCommission);
        const taqeebValue = Number(globalSettings.taqeebCommission);
        
        // التحقق من صحة القيم
        if (isNaN(contractValue) || isNaN(taqeebValue)) {
            throw new Error('يرجى إدخال قيم صالحة للعمولات');
        }
        
        // إرسال البيانات إلى الخادم
        const response = await fetch(`${config.DELEGATES_API_URL}/api/simple-settings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contractCommission: contractValue,
                taqeebCommission: taqeebValue
            })
        });
        
        const data = await response.json();
        console.log("استجابة الخادم:", data);
        
        if (!data.success) {
            throw new Error(data.error || 'فشل في حفظ الإعدادات');
        }
        
        // تحديث الإعدادات المحلية لضمان عرض القيم المحدثة
        setGlobalSettings(prev => ({
            ...prev,
            contractCommission: contractValue,
            taqeebCommission: taqeebValue
        }));
        
        alert('تم حفظ الإعدادات العامة بنجاح');
        
        // إغلاق النافذة بعد النجاح (اختياري)
        // يمكنك إزالة هذا السطر إذا كنت تريد أن يبقى المستخدم في النافذة
        if (typeof onClose === 'function') {
            setTimeout(onClose, 500); // إغلاق النافذة بعد نصف ثانية للسماح للمستخدم برؤية رسالة النجاح
        }
        
        // إضافة آلية لإخبار الشاشة الرئيسية بالتحديث (إذا كان متاحًا)
        if (typeof window.parent !== 'undefined' && typeof window.parent.postMessage === 'function') {
            window.parent.postMessage({
                type: 'SETTINGS_UPDATED',
                data: { contractCommission: contractValue, taqeebCommission: taqeebValue }
            }, '*');
        }
        
        // إضافة استدعاء لدالة محددة في الصفحة الرئيسية إذا كانت موجودة
        if (typeof window.updateMainPageSettings === 'function') {
            window.updateMainPageSettings({ 
                contractCommission: contractValue, 
                taqeebCommission: taqeebValue 
            });
        }
        
        return true;
    } catch (error) {
        console.error('خطأ في حفظ الإعدادات العامة:', error);
        setError(`خطأ في حفظ الإعدادات العامة: ${error.message}`);
        return false;
    } finally {
        setLoading(false);
    }
};
    
// معالجة تغيير إعدادات عمولة الشركة
const handleSettingChange = (companyId, field, value) => {
    console.log(`تغيير إعدادات الشركة ${companyId}: ${field} = ${value}`);
    
    // تشخيص المشكلة قبل التعديل
    const company = companies.find(c => c.CompanyID.toString() === companyId.toString());
    if (company) {
        debugCompanySettings(settings, companies, companyId, company.CompanyName);
    }
    
    // تحديث الحالة المحلية مع التأكد من نوع البيانات
    setSettings(prevSettings => {
        const updatedSettings = prevSettings.map(setting => {
            if (setting.companyId.toString() === companyId.toString()) {
                const updatedSetting = {
                    ...setting,
                    companyId: parseInt(companyId), // توحيد نوع البيانات
                    [field]: field === 'useAutoCalculation' ? 
                        Boolean(value) : 
                        (value === '' || isNaN(parseFloat(value))) ? 0 : parseFloat(value)
                };
                
                console.log('الإعدادات بعد التحديث:', updatedSetting);
                return updatedSetting;
            }
            return setting;
        });
        
        // تحديث localStorage فوراً
        const localStorageData = JSON.parse(localStorage.getItem('companySettings') || '[]');
        const updatedLocalData = localStorageData.filter(s => s.companyId.toString() !== companyId.toString());
        const newSetting = updatedSettings.find(s => s.companyId.toString() === companyId.toString());
        
        if (newSetting) {
            updatedLocalData.push({
                companyId: parseInt(companyId),
                newClientCommission: newSetting.newClientCommission,
                oldClientCommission: newSetting.oldClientCommission,
                useAutoCalculation: newSetting.useAutoCalculation
            });
            
            localStorage.setItem('companySettings', JSON.stringify(updatedLocalData));
            console.log('تم تحديث localStorage للشركة:', companyId);
        }
        
        return updatedSettings;
    });
};

const resetCompanySettings = (companyId) => {
    console.log(`إعادة ضبط إعدادات الشركة: ${companyId}`);
    
    // حذف من localStorage
    const localData = JSON.parse(localStorage.getItem('companySettings') || '[]');
    const filteredData = localData.filter(s => s.companyId.toString() !== companyId.toString());
    localStorage.setItem('companySettings', JSON.stringify(filteredData));
    
    // إعادة ضبط في الحالة المحلية
    setSettings(prevSettings => 
        prevSettings.map(setting => 
            setting.companyId.toString() === companyId.toString() ? {
                companyId: parseInt(companyId),
                newClientCommission: 100,
                oldClientCommission: 50,
                contractCommission: 200,
                taqeebCommission: 150,
                useAutoCalculation: true,
                companyName: setting.companyName
            } : setting
        )
    );
    
    alert(`تم إعادة ضبط إعدادات الشركة بنجاح`);
};



const syncAllSettings = async () => {
    try {
        setLoading(true);
        
        // مسح localStorage بالكامل
        localStorage.removeItem('companySettings');
        
        // إعادة جلب البيانات من الخادم
        const response = await fetch(`${config.DELEGATES_API_URL}/api/commission-settings/all`);
        let serverData = [];
        
        if (response.ok) {
            serverData = await response.json();
        }
        
        // إنشاء إعدادات افتراضية لجميع الشركات
        const defaultSettings = companies.map(company => ({
            companyId: parseInt(company.CompanyID),
            companyName: company.CompanyName,
            newClientCommission: 100,
            oldClientCommission: 50,
            contractCommission: 200,
            taqeebCommission: 150,
            useAutoCalculation: true
        }));
        
        // دمج الإعدادات الموجودة مع الافتراضية
        const mergedSettings = defaultSettings.map(defaultSetting => {
            const serverSetting = serverData.find(s => 
                parseInt(s.companyId) === defaultSetting.companyId
            );
            
            return serverSetting ? {
                ...defaultSetting,
                ...serverSetting,
                companyId: parseInt(serverSetting.companyId)
            } : defaultSetting;
        });
        
        setSettings(mergedSettings);
        
        // حفظ في localStorage
        const localStorageData = mergedSettings.map(setting => ({
            companyId: setting.companyId,
            newClientCommission: setting.newClientCommission,
            oldClientCommission: setting.oldClientCommission,
            useAutoCalculation: setting.useAutoCalculation
        }));
        
        localStorage.setItem('companySettings', JSON.stringify(localStorageData));
        
        alert('تم مزامنة جميع الإعدادات بنجاح');
        
    } catch (error) {
        console.error('خطأ في المزامنة:', error);
        alert('حدث خطأ في المزامنة');
    } finally {
        setLoading(false);
    }
};
    
    // فلترة الشركات حسب البحث
    const filteredCompanies = companies.filter(company => 
        company.CompanyName.includes(search)
    );
    
    if (!isOpen) return null;
    
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" dir="rtl">
            <div className="relative mx-auto p-5 border w-full max-w-4xl shadow-lg rounded-md bg-white mt-10">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                        <Settings className="ml-2" size={20} />
                        إعدادات العمولات
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-500"
                    >
                        <X size={20} />
                    </button>
                </div>
                
                {error && (
                    <div className="bg-red-50 border border-red-200 text-red-600 p-3 rounded-md mb-4 flex items-center">
                        <AlertTriangle size={18} className="ml-2" />
                        {error}
                    </div>
                )}
                
              {/* تبويبات الإعدادات */}
<div className="flex justify-between items-center mb-4">
    <div className="flex bg-gray-100 rounded-lg">
        <button
            className={`flex-1 py-2 rounded-lg ${activeTab === 'global' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700'}`}
            onClick={() => setActiveTab('global')}
        >
            <span className="flex items-center justify-center gap-1">
                <Layers size={16} />
                الإعدادات العامة
            </span>
        </button>
        <button
            className={`flex-1 py-2 rounded-lg ${activeTab === 'companies' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700'}`}
            onClick={() => setActiveTab('companies')}
        >
            <span className="flex items-center justify-center gap-1">
                <Settings size={16} />
                إعدادات الشركات
            </span>
        </button>
    </div>
    
    {activeTab === 'companies' && (
        <button
            onClick={syncAllSettings}
            disabled={loading}
            className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-1"
        >
            <Settings className={loading ? 'animate-spin' : ''} size={16} />
            مزامنة شاملة
        </button>
    )}
</div>
                
                {/* محتوى التبويبات */}
                {activeTab === 'global' ? (
                    /* تبويب الإعدادات العامة */
                    <div className="bg-white p-4 rounded-lg border">
                        <h4 className="font-medium text-gray-800 mb-3">إعدادات العمولات العامة</h4>
                        
                        <div className="border rounded-lg p-4 bg-blue-50 border-blue-200 mb-3">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    عمولة العقد (لجميع الشركات)
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                        <DollarSign size={16} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="number"
                                        value={globalSettings.contractCommission}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setGlobalSettings(prev => ({
                                                ...prev,
                                                contractCommission: value
                                            }));
                                        }}
                                        className="pr-10 pl-2 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm rounded-md"
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    عمولة التعقيب (لجميع الشركات)
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                        <DollarSign size={16} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="number"
                                        value={globalSettings.taqeebCommission}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setGlobalSettings(prev => ({
                                                ...prev,
                                                taqeebCommission: value
                                            }));
                                        }}
                                        className="pr-10 pl-2 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm rounded-md"
                                    />
                                </div>
                            </div>
                        </div>
                            
                            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                                <p className="text-sm text-yellow-700">
                                    <strong>ملاحظة:</strong> هذه الإعدادات ستطبق على جميع الشركات. عمولات العقد والتعقيب موحدة لجميع الشركات.
                                </p>
                            </div>
                        </div>
                        

                                
                                <div className="flex justify-end">
                                    <button
                                        type="button"
                                        onClick={saveGlobalSettings}
                                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md flex items-center gap-1"
                                        disabled={loading}
                                    >
                                        <Save size={16} />
                                        <span>حفظ الإعدادات العامة</span>
                                    </button>
                                </div>
                            </div>
                ) : (
                    /* تبويب إعدادات الشركات */
                    <>
                        {/* شريط البحث */}
                        <div className="mb-4">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="بحث عن شركة..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="w-full border border-gray-300 rounded-lg pl-10 pr-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                                <Search className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
                            </div>
                        </div>
                        
                        {loading && (
                            <div className="flex justify-center py-8">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                            </div>
                        )}
                        
                        {!loading && (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto">
                                {filteredCompanies.map(company => {
                               const companySetting = settings.find(s => 
                                s.companyId.toString() === company.CompanyID.toString() // ← تصحيح المقارنة
                            ) || {
                                companyId: parseInt(company.CompanyID), // ← توحيد نوع البيانات
                                newClientCommission: 100,
                                oldClientCommission: 50,
                                contractCommission: 200,
                                taqeebCommission: 150,
                                useAutoCalculation: true
                            };
                                    
                                    const isSelected = selectedCompany === company.CompanyID;
                                    
                                    return (
                                        <div 
                                            key={company.CompanyID} 
                                            className="border rounded-lg overflow-hidden"
                                        >
                                            <div 
                                                className={`flex justify-between items-center p-3 cursor-pointer ${isSelected ? 'bg-blue-50 border-blue-500' : 'bg-white border-gray-200 hover:bg-gray-50'}`}
                                                onClick={() => setSelectedCompany(isSelected ? null : company.CompanyID)}
                                            >
                                                <div className="font-medium">{company.CompanyName}</div>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-sm text-gray-500">
                                                        {companySetting.useAutoCalculation ? 'الحساب التلقائي مفعل' : 'الحساب التلقائي معطل'}
                                                    </span>
                                                    {isSelected ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                                                </div>
                                            </div>
                                            
                                                {isSelected && (
                                                    <div className="p-4 bg-gray-50 border-t border-gray-200">
                                                        <div className="flex items-center justify-between mb-3">
                                                            <label className="text-sm font-medium text-gray-700">
                                                                استخدام الحساب التلقائي للعمولات
                                                            </label>
                                                            <label className="relative inline-flex items-center cursor-pointer">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={companySetting.useAutoCalculation}
                                                                    onChange={(e) => handleSettingChange(company.CompanyID, 'useAutoCalculation', e.target.checked)}
                                                                    className="sr-only peer"
                                                                />
                                                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                                            </label>
                                                        </div>
                                                        
                                                        <div className="border rounded-lg p-4 bg-blue-50 border-blue-200 mb-3">
                                                            <h4 className="font-medium text-blue-800 mb-3">مبالغ العمولات (ريال)</h4>
                                                            
                                                            <div className="grid grid-cols-2 gap-4">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                        عميل جديد
                                                                    </label>
                                                                    <div className="relative">
                                                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                                                            <DollarSign size={16} className="text-gray-400" />
                                                                        </div>
                                                                        <input
                                                                            type="number"
                                                                            value={companySetting.newClientCommission}
                                                                            onChange={(e) => handleSettingChange(company.CompanyID, 'newClientCommission', e.target.value)}
                                                                            className="pr-10 pl-2 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm rounded-md"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                        عميل قديم
                                                                    </label>
                                                                    <div className="relative">
                                                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                                                            <DollarSign size={16} className="text-gray-400" />
                                                                        </div>
                                                                        <input
                                                                            type="number"
                                                                            value={companySetting.oldClientCommission}
                                                                            onChange={(e) => handleSettingChange(company.CompanyID, 'oldClientCommission', e.target.value)}
                                                                            className="pr-10 pl-2 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm rounded-md"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                                                                <p className="text-sm text-yellow-700">
                                                                    <strong>ملاحظة:</strong> إعدادات العقد والتعقيب توجد في قسم "الإعدادات العامة" وهي موحدة لجميع الشركات.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="flex justify-end">


                                                        <div className="flex gap-2 mb-3">
                                                        
                                                        </div>



                                                            <button
                                                                type="button"
                                                                onClick={async () => {
                                                                    const success = await saveCompanySettings(company.CompanyID, {
                                                                        newClientCommission: companySetting.newClientCommission,
                                                                        oldClientCommission: companySetting.oldClientCommission,
                                                                        useAutoCalculation: companySetting.useAutoCalculation
                                                                    });
                                                                    
                                                                    if (success) {
                                                                        alert(`تم حفظ إعدادات شركة ${company.CompanyName} بنجاح`);
                                                                    }
                                                                }}
                                                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md flex items-center gap-1"
                                                                disabled={loading}
                                                            >
                                                                <Save size={16} />
                                                                <span>حفظ الإعدادات</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </>
                )}
                
                <div className="bg-gray-50 p-3 rounded-md mt-4">
                    <p className="text-sm text-gray-500">
                        ملاحظة: العميل يعتبر قديم إذا كان مسجل على شركة وأيضًا هذه الشركة نفسها موجودة في خانة "قديم شركات".
                    </p>
                </div>
                
                <div className="flex items-center justify-end mt-4 pt-3 border-t">
                    <button
                        type="button"
                        onClick={onClose}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CommissionSettings;